module.exports = __webpack_public_path__ + "img/story001@2x.66e4463c.webp";